import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

type Props = {
  progress: number;
  size?: number;
  filledColor: string;
  unfilledColor?: string;
  label: string;
  gapDeg?: number;
};

const CustomDoughnut: React.FC<Props> = ({
  progress,
  size = 190,
  filledColor,
  unfilledColor = "#EDF3F9",
  label,
  gapDeg = 3,
}) => {
  const ref = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    const radius = size / 2;
    const filledThickness = 44;
    const unfilledThickness = 35;

    const gapRad = (gapDeg * Math.PI) / 180;
    const svg = d3
      .select(ref.current)
      .attr("width", size)
      .attr("height", size)
      .attr("viewBox", `0 0 ${size} ${size}`);

    svg.selectAll("*").remove();

    const g = svg
      .append("g")
      .attr("transform", `translate(${radius},${radius})`);

    const arc = d3.arc();

    g.append("path")
      .attr(
        "d",
        arc({
          innerRadius: radius - filledThickness,
          outerRadius: radius - filledThickness + unfilledThickness,
          startAngle: 0,
          endAngle: 2 * Math.PI,
        }) as string
      )
      .attr("fill", unfilledColor);

    const totalAngle = (progress / 100) * 2 * Math.PI;
    const adjustedAngle = Math.max(0, totalAngle - 2 * gapRad);
    // filled arc
    g.append("path")
      .attr(
        "d",
        arc({
          innerRadius: radius - filledThickness,
          outerRadius: radius,
          startAngle: gapRad,
          endAngle: gapRad + adjustedAngle,
        }) as string
      )
      .attr("fill", filledColor);

    g.append("text")
      .attr("text-anchor", "middle")
      .attr("dy", "-0.2em")
      .attr("font-size", "24px")
      .attr("font-weight", "600")
      .attr("fill", filledColor)
      .text(`${progress || 0}%`);

    g.append("text")
      .attr("text-anchor", "middle")
      .attr("dy", "1.2em")
      .attr("font-size", "14px")
      .attr("font-weight", "500")
      .attr("fill", filledColor)
      .text(label.toUpperCase());
  }, [progress, size, filledColor, unfilledColor, label, gapDeg]);

  return <svg ref={ref}></svg>;
};

export default CustomDoughnut;
